import { SelectOptionElement } from '@odin-labs/components';
import { SessionDisplayColumns } from 'apollo/generated/client-operations';

export type DeveloperForOption = {
  developerId: string;
  organization: { name: string };
};
export type JobsiteForOption = {
  jobsiteId: string;
  name: string;
  parentId?: string;
};
export type JobsiteTemplateForOption = JobsiteForOption & {
  developer?: { developerId: string };
};
export type JobsiteTemplateOption = SelectOptionElement & {
  developerId: string;
};

export const getDevelopersOptions = (
  developers: DeveloperForOption[],
): SelectOptionElement[] =>
  developers?.map(({ developerId: value, organization: { name: label } }) => ({
    value,
    label,
  }));

export const getJobsiteOptions = (
  jobsites: JobsiteForOption[],
): SelectOptionElement[] =>
  jobsites?.map(({ jobsiteId: value, name: label }) => ({ value, label }));

export const getJobsiteTemplateOptions = (
  jobsites: JobsiteTemplateForOption[],
): JobsiteTemplateOption[] =>
  jobsites?.map(
    ({ jobsiteId: value, name: label, developer: { developerId } }) => ({
      value,
      label,
      developerId,
    }),
  );

export const getSessionDisplayColumnOptions = (): SelectOptionElement[] => {
  // Sort alphabetically, but keep SmartBalancedGross directly after BalancedGross.
  type SessionDisplayColumnKey = keyof typeof SessionDisplayColumns;
  const sortKey = (label: SessionDisplayColumnKey): string =>
    label === 'SmartBalancedGross' ? 'BalancedGross#' : label;

  return (Object.keys(SessionDisplayColumns) as SessionDisplayColumnKey[])
    .sort((a, b) => sortKey(a).localeCompare(sortKey(b)))
    .map((label) => ({
      label,
      value: SessionDisplayColumns[label]?.toString(),
    }));
};
